module.exports = __webpack_public_path__ + "img/N123.a0211160.jpg";